import { render } from "./ThePromocodeList.vue?vue&type=template&id=3b012bb4&scoped=true&ts=true&lang=html"
import script from "./ThePromocodeList.vue?vue&type=script&lang=ts"
export * from "./ThePromocodeList.vue?vue&type=script&lang=ts"

import "./ThePromocodeList.vue?vue&type=style&index=0&id=3b012bb4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b012bb4"]])

export default __exports__